
import { ModalComparisionRepository } from '../repositories/ModalComparisionRepository';

export class ModalCompareService {
  private repository: ModalComparisionRepository;

  constructor() {
    this.repository = ModalComparisionRepository.getInstance();
  }

  public async compareModal(payload: any): Promise<any> {
    return await this.repository.compare(payload);
  }

}

// Export singleton instance
export const modalCompareService = new ModalCompareService();
